module.exports = __webpack_public_path__ + "img/mobile_info.928caa44.png";